import { PlatformAgeAssuranceResult } from '../types';

// Keep this file free of expo-age-range imports so web bundles never load the native module.
export const requestPlatformAgeAssurance = async (): Promise<PlatformAgeAssuranceResult> => ({
  outcome: 'native_unavailable',
  nativeResult: 'response_missing',
});
